module.exports = __webpack_public_path__ + "media/1.85a2cdc3.mp3";